/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 */

import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Result, Button } from 'antd';

import VertGrowableRowWrapper from 'containers/VertGrowableRowWrapper';
import { getSpecialisationFromLocation } from 'utils/utils';

import { NotFoundWrapper } from './styles';

function NotFound({ location }) {
  const specialisation = getSpecialisationFromLocation(location);
  return (
    <VertGrowableRowWrapper>
      <NotFoundWrapper>
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Link to={specialisation ? `/${specialisation}` : '/'}>
              <Button type="primary">Back Home</Button>
            </Link>
          }
        />
      </NotFoundWrapper>
    </VertGrowableRowWrapper>
  );
}

NotFound.propTypes = {
  location: PropTypes.object.isRequired,
};

export default withRouter(NotFound);
